import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Sparkles, LogOut, Crown } from "lucide-react";

export const Nav = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const link = (to, label, testid) => {
    const active = location.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.25em] whitespace-nowrap transition-colors ${
          active ? "text-[#E3C2B0]" : "text-[#A8A6A1] hover:text-[#F7F5F2]"
        }`}
      >
        {label}
      </Link>
    );
  };

  const planLabel = user?.is_admin
    ? "Admin"
    : user?.tier === "premium"
    ? "Premium"
    : user?.tier === "basic"
    ? "Basic"
    : user?.tier === "free" && user?.is_active
    ? "Free"
    : null;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-2xl bg-black/60 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-5 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 flex-shrink-0">
          <Sparkles className="w-4 h-4 text-[#E3C2B0]" strokeWidth={1.5} />
          <span className="font-serif text-xl sm:text-2xl tracking-tight text-[#F7F5F2]">StyleMe</span>
        </Link>
        <nav className="flex items-center gap-3 sm:gap-8">
          {user ? (
            <>
              {link("/studio", "Studio", "nav-studio")}
              {link("/gallery", "Gallery", "nav-gallery")}
              {user?.is_admin && link("/admin/metrics", "Admin", "nav-admin")}
              <Link
                to="/subscription"
                data-testid="nav-subscription"
                className="inline-flex items-center gap-1.5 sm:gap-2 border border-white/15 px-2 sm:px-3 py-1.5 rounded-sm text-[10px] uppercase tracking-[0.15em] sm:tracking-[0.25em] hover:border-[#E3C2B0] transition-colors whitespace-nowrap"
              >
                <Crown className="w-3 h-3 text-[#E3C2B0]" strokeWidth={1.5} />
                <span className="hidden sm:inline">{planLabel || "Subscribe"}</span>
              </Link>
              <button
                onClick={handleLogout}
                data-testid="nav-logout"
                className="text-[#A8A6A1] hover:text-[#F7F5F2] transition-colors flex-shrink-0"
                aria-label="Logout"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </>
          ) : (
            <>
              {link("/auth?mode=login", "Sign In", "nav-signin")}
              <Link
                to="/auth?mode=register"
                data-testid="nav-signup"
                className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.25em] bg-[#E3C2B0] text-[#0A0908] px-3 sm:px-5 py-2 sm:py-2.5 rounded-sm hover:bg-[#F0D4C5] transition-colors whitespace-nowrap"
              >
                Get Started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
